// auto generated please run `yarn icon-sprite`
const IconName = {
  ACTIVE_ARROW_LINK: 'active-arrow-link',
  ACTIVITY_VIDEOS: 'activity-videos',
  ACTIVITY: 'activity',
  ADMIN_ICON_UK: 'admin-icon-uk',
  ANDROID: 'android',
  APP_MOBILE: 'app-mobile',
  APP_STORE: 'app-store',
  APPLE: 'apple',
  ARROW_DRAWN: 'arrow-drawn',
  ARROW_FLIP: 'arrow-flip',
  ARROW_NEW: 'arrow-new',
  ARROW: 'arrow',
  AUDIO: 'audio',
  BASKET: 'basket',
  BEFORE: 'before',
  BLACK_AND_WHITE: 'black-and-white',
  BLOCK_ARROW: 'block-arrow',
  BLOCKQUOTE: 'blockquote',
  BODY_MAGIC_AWARD: 'body-magic-award',
  BODY_MAGIC: 'body-magic',
  BOOKMARK: 'bookmark',
  BULLETED_LIST: 'bulleted-list',
  BULLSEYE_TARGET: 'bullseye-target',
  CALCIUM: 'calcium',
  CALENDAR_1: 'calendar-1',
  CALENDAR_LARGE: 'calendar-large',
  CALENDAR: 'calendar',
  CAMERA: 'camera',
  CHECKMARK: 'checkmark',
  CHECKOUT_BASKET: 'checkout_basket',
  CHEVRON_LARGE: 'chevron-large',
  CHEVRON: 'chevron',
  CHILLI: 'chilli',
  CIRCLE_MINUS: 'circle-minus',
  CIRCLE_PLUS: 'circle-plus',
  CLOCK: 'clock',
  COMMENT_BORDER: 'comment-border',
  COMMENT_FILLED: 'comment-filled',
  COMMENTED_FILLED: 'commented-filled',
  COMMUNITY_MENTION: 'community-mention',
  COMMUNITY: 'community',
  CONTACT_US: 'contact_us',
  COPY: 'copy',
  CROSS: 'cross',
  CURRENT_WEIGHT: 'current-weight',
  CYP_FLAG: 'cyp-flag',
  DAIRY_FREE: 'dairy-free',
  DOWNLOAD_LARGE: 'download-large',
  DOWNLOAD: 'download',
  EDIT: 'edit',
  EMOTION_DISAPOINTED: 'emotion-disapointed',
  EMOTION_FRUSTRATED: 'emotion-frustrated',
  EMOTION_PLEASED: 'emotion-pleased',
  EMOTION_THRILLED: 'emotion-thrilled',
  EMOTION_UPSET: 'emotion-upset',
  ENLARGE: 'enlarge',
  ENVELOPE_EMAIL: 'envelope-email',
  EVERY_MIND_MATTERS: 'every-mind-matters',
  EYE_HIDE: 'eye-hide',
  EYE_OPEN: 'eye-open',
  FACEBOOK: 'facebook',
  FEATURES: 'features',
  FEMALE: 'female',
  FIBRE: 'fibre',
  FILTER: 'filter',
  FLAG: 'flag',
  FO_STEP_ONE_CIRCLE: 'fo-step-one-circle',
  FO_STEP_THREE_CIRCLE: 'fo-step-three-circle',
  FO_STEP_TWO_CIRCLE: 'fo-step-two-circle',
  FOOD_BOWL: 'food-bowl',
  FOOD_GUIDES: 'food-guides',
  FOOD_OPTIMISING_BOOKMARK_ICON: 'food-optimising-bookmark-icon',
  FOOD_OPTIMISING_ESSENTIALS: 'food-optimising-essentials',
  FOOD_OPTIMISING_HERO_AWARD: 'food-optimising-hero-award',
  FOOD_OPTIMISING_MENU: 'food-optimising-menu',
  FOOD_SEARCH: 'food-search',
  FOOTPRINTS: 'footprints',
  FREE_FOODS_NEW: 'free-foods-new',
  FREE_FOODS: 'free-foods',
  FREEZER_FRIENDLY: 'freezer-friendly',
  FULL_COLOUR: 'full-colour',
  GLUTEN_FREE: 'gluten-free',
  GOOGLE_PLAY_STORE: 'google-play-store',
  GROUP_SUPPORT: 'group-support',
  HALF_FRACTION_AWARD: 'half-fraction-award',
  HALF_FRACTION: 'half-fraction',
  HALL_OF_FAME: 'hall-of-fame',
  HAMBURGER: 'hamburger',
  HAND_DRAWN_ARROW: 'hand-drawn-arrow',
  HEALTHY_EXTRA_A: 'healthy-extra-a',
  HEALTHY_EXTRA_CALCIUM: 'healthy-extra-calcium',
  HEALTHY_EXTRA_FIBRE: 'healthy-extra-fibre',
  HEALTHY_EXTRA_HEALTHY_FATS: 'healthy-extra-healthy-fats',
  HEALTHY_EXTRAS_ALL: 'healthy-extras-all',
  HEALTHY_EXTRAS: 'healthy-extras',
  HEART_LIKE_BORDER: 'heart-like-border',
  HEART_LIKED_FILLED: 'heart-liked-filled',
  HEART_WHITE_BORDER: 'heart-white-border',
  HEIGHT: 'height',
  HIGHLIGHTER: 'highlighter',
  HOME: 'home',
  ICELAND_LOGO: 'iceland-logo',
  ICELAND_SP: 'iceland-sp',
  ICELAND_VEGAN: 'iceland-vegan',
  ICELAND_VEGETARIAN: 'iceland-vegetarian',
  IDEA: 'idea',
  INFORMATION: 'information',
  INSTAGRAM_CAMCORDER: 'instagram-camcorder',
  INSTAGRAM: 'instagram',
  IPSO: 'ipso',
  LIGHTBULB: 'lightbulb',
  LIST_HEART: 'list-heart',
  LIST_SEARCH: 'list-search',
  LOCATION_TARGET: 'location-target',
  LOCK: 'lock',
  LOGO_CLASSIC_MOBILE: 'logo-classic-mobile',
  LOGO_CLASSIC: 'logo-classic',
  LOGO_MODERN_MOBILE: 'logo-modern-mobile',
  LOGOUT: 'logout',
  MAGNIFY_GLASS: 'magnify-glass',
  MALE: 'male',
  MAP_MARKER_SYMBOL: 'map-marker-symbol',
  MAP_PIN: 'map-pin',
  MENU_SLIMMING_GROUP: 'menu-slimming-group',
  MENU_BOOKMARK: 'menu_bookmark',
  MINUS: 'minus',
  MOBILE_SUPPORT_ARROW: 'mobile-support-arrow',
  MUSCLE: 'muscle',
  MUTE: 'mute',
  NOTIFICATIONS: 'notifications',
  ONLINE_MEMBER_EVENTS: 'online-member-events',
  PAPERCLIP: 'paperclip',
  PAUSE: 'pause',
  PDF: 'pdf',
  PERSON_FILLED: 'person-filled',
  PERSON: 'person',
  PIN: 'pin',
  PINTEREST: 'pinterest',
  PLANNER: 'planner',
  PLAY: 'play',
  PLUS: 'plus',
  PODCAST_HEART: 'podcast-heart',
  PODCAST: 'podcast',
  PREGNANCY_ROUNDEL: 'pregnancy-roundel',
  PRINT: 'print',
  PROFILE: 'profile',
  PROTEIN: 'protein',
  RECIPES: 'recipes',
  RECURRING_PAYMENT: 'recurring-payment',
  REGISTERED_TRADEMARK_SYMBOL: 'registered-trademark-symbol',
  REPLY: 'reply',
  RESET: 'reset',
  ROI_FLAG: 'roi-flag',
  SCALE_BORDER: 'scale-border',
  SCALE_PIN: 'scale-pin',
  SCALE: 'scale',
  SCT_FLAG: 'sct-flag',
  SHARE_EXPORT: 'share-export',
  SHARE: 'share',
  SIGN_UP: 'sign-up',
  SIGNIN: 'signin',
  SLIMMING_WORLD_KITCHEN: 'slimming-world-kitchen',
  SMILES_CHARITY_LOGO: 'smiles-charity-logo',
  SOUND_OFF: 'sound-off',
  SOUND_ON: 'sound-on',
  SP_SECONDARY: 'sp-secondary',
  SP: 'sp',
  SPEED: 'speed',
  SUCCESS_STORIES: 'success-stories',
  SUPPORT: 'support',
  SW_LOGO_PRIMARY_WHITE: 'sw-logo-primary-white',
  SW_LOGO_PRIMARY: 'sw-logo-primary',
  SYNS_ALLOWANCE: 'syns-allowance',
  TAGS: 'tags',
  TICK: 'tick',
  TIME: 'time',
  TRASH: 'trash',
  TROPHY: 'trophy',
  TRUST_PILOT: 'trust-pilot',
  TUMBLR: 'tumblr',
  TWITTER: 'twitter',
  UK_FLAG: 'uk-flag',
  UNDERLINE_SWOOSH_SMALL: 'underline-swoosh-small',
  UNDERLINE_SWOOSH: 'underline-swoosh',
  UNLOCKED: 'unlocked',
  VEGAN: 'vegan',
  VEGETARIAN: 'vegetarian',
  WATCH: 'watch',
  WEIGHT_LOSS_MEDICATION: 'weight-loss-medication',
  WEIGHT_LOSS_ROUNDEL: 'weight-loss-roundel',
  WHOLEGRAIN: 'wholegrain',
  MAGIC_MOVER_AWARD: 'magic-mover-award',
};

export default IconName;
